/* =========================
   Cart Drawer + AJAX Add
   ========================= */
(function () {
  const SELECTORS = {
    root:    '#cart-drawer',
    overlay: '[data-cart-overlay]',
    close:   '[data-cart-close]',
    items:   '[data-cart-items]',
    total:   '[data-cart-total]',
    freeMsg: '[data-free-ship-msg]',
    freeFill:'[data-free-ship-fill]',
    recs:    '[data-cart-recs]',
    recGrid: '[data-recs-grid]'
  };

  // Edit to your free-shipping threshold (in cents)
  const FREE_SHIP_THRESHOLD = 100 * 100;

  // Badge targets — add your theme’s selectors if different
  const COUNT_TARGETS = [
    '[data-cart-count]',
    '.cart-count-bubble',
    '#CartCount'
  ];

  const el = {};
  const qs  = (sel, root=document)=> root.querySelector(sel);
  const qsa = (sel, root=document)=> Array.from(root.querySelectorAll(sel));
  const money = (cents)=> (cents/100).toLocaleString(Shopify?.locale || 'en', { style:'currency', currency: Shopify?.currency?.active || 'USD' });

  function setCartCount(n){
    const count = Number(n) || 0;
    qsa(COUNT_TARGETS.join(',')).forEach(badge=>{
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === 0);
      badge.setAttribute('aria-hidden', String(count === 0));
    });
    document.dispatchEvent(new CustomEvent('cart:count-updated', { detail:{ count } }));
  }

  function openDrawer(){
    const root = qs(SELECTORS.root);
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
  }
  function closeDrawer(){
    const root = qs(SELECTORS.root);
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
  }

  async function fetchCart(){
    const res = await fetch('/cart.js', { headers:{ 'Accept':'application/json' }});
    return res.json();
  }

  function lineItemHTML(item){
    const props = item.properties
      ? Object.entries(item.properties)
          .filter(([k]) => k !== '__FOKKIO_shop_surprise_promotion_id')
          .map(([k, v]) => `<div>${k}: ${v}</div>`)
          .join('')
      : '';
    const selling = item.selling_plan_allocation ? `<div>${item.selling_plan_allocation.selling_plan.name}</div>` : '';

    // Try to request a smaller image without assuming image type
    const img = item.image ? item.image.replace(/(\.[a-z]+)$/i, '_100x$1') : '';

    return `
      <div class="cartDrawer__item" data-key="${item.key}">
        <img class="cartDrawer__img" src="${img}" alt="${item.title}">
        <div>
          <h4 class="cartDrawer__title"><a href="${item.url}">${item.product_title}</a></h4>
          <div class="cartDrawer__meta">
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div>${item.variant_title}</div>` : ''}
            ${props}
            ${selling}
          </div>
          <div class="cartDrawer__qty" data-qty>
            <button type="button" data-qty-dec aria-label="Decrease">−</button>
            <input type="number" min="0" value="${item.quantity}" data-qty-input>
            <button type="button" data-qty-inc aria-label="Increase">+</button>
            <button class="cartDrawer__remove" type="button" data-remove aria-label="Remove">🗑</button>
          </div>
        </div>
        <div class="cartDrawer__price">${money(item.final_line_price)}</div>
      </div>
    `;
  }

  async function render(){
    const cart = await fetchCart();

    // Line items
    if (el.items) {
      el.items.innerHTML = cart.items.length ? cart.items.map(lineItemHTML).join('') : `<p class="cart-empty">Your cart is empty.</p>`;
    }

    // Total
    if (el.total) el.total.textContent = money(cart.total_price);

    // Free-shipping progress
    if (el.freeFill && el.freeMsg) {
      const remaining = Math.max(FREE_SHIP_THRESHOLD - cart.total_price, 0);
      const pct = Math.min((cart.total_price / FREE_SHIP_THRESHOLD) * 100, 100);
      el.freeFill.style.width = `${pct}%`;
      el.freeMsg.textContent = remaining > 0
        ? `You're ${money(remaining)} away from FREE shipping and FREE Gift!`
        : `You unlocked FREE shipping and FREE Gift!`;
    }

    // Recommendations
    if (el.recs && el.recGrid) {
      if (cart.items.length) {
        try {
          const first = cart.items[0];
          const recUrl = `/recommendations/products.json?product_id=${first.product_id}&limit=4`;
          const recRes = await fetch(recUrl);
          const recData = await recRes.json();
          if (recData && recData.products && recData.products.length) {
            el.recs.hidden = false;
            el.recGrid.innerHTML = recData.products.map(p => {
              const img = p.images?.[0]?.src ? p.images[0].src.replace(/(\.[a-z]+)$/i, '_120x$1') : '';
              const priceCents = Math.round(parseFloat(p.variants[0].price) * 100);
              return `
                <div class="cartDrawer__rec" data-rec-id="${p.id}">
                  <div style="display:flex;gap:10px;align-items:center">
                    <img src="${img}" alt="${p.title}">
                    <div>
                      <div class="cartDrawer__rec-title">${p.title}</div>
                      <div class="cartDrawer__rec-price">${money(priceCents)}</div>
                    </div>
                  </div>
                  <button type="button" data-rec-add data-variant="${p.variants[0].id}">Add</button>
                </div>
              `;
            }).join('');
          } else {
            el.recs.hidden = true;
            el.recGrid.innerHTML = '';
          }
        } catch(e){
          el.recs.hidden = true;
          el.recGrid.innerHTML = '';
        }
      } else {
        el.recs.hidden = true;
        el.recGrid.innerHTML = '';
      }
    }

    // Update header cart count
    setCartCount(cart.item_count);
  }

  async function changeQuantity(key, qty){
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await render();
  }
  async function removeItem(key){ return changeQuantity(key, 0); }

  async function addVariant(variantId, quantity=1, properties){
    await fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    await render();
    openDrawer();
  }

  function bind(){
    const root = qs(SELECTORS.root);
    if (!root) return;

    el.items   = qs(SELECTORS.items, root);
    el.total   = qs(SELECTORS.total, root);
    el.freeMsg = qs(SELECTORS.freeMsg, root);
    el.freeFill= qs(SELECTORS.freeFill, root);
    el.recs    = qs(SELECTORS.recs, root);
    el.recGrid = qs(SELECTORS.recGrid, root);

    // Open triggers
    qsa('[data-open-cart]').forEach(btn =>
      btn.addEventListener('click', (e)=>{ e.preventDefault(); openDrawer(); render(); })
    );

    // Close
    qs(SELECTORS.overlay, root)?.addEventListener('click', closeDrawer);
    qs(SELECTORS.close, root)?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') closeDrawer(); });

    // Quantity/remove (delegated)
    el.items?.addEventListener('click', (e)=>{
      const itemEl = e.target.closest('.cartDrawer__item'); if(!itemEl) return;
      const key = itemEl.getAttribute('data-key');
      if (e.target.matches('[data-qty-inc]')) {
        const val = parseInt(qs('[data-qty-input]', itemEl).value, 10) + 1;
        changeQuantity(key, val);
      }
      if (e.target.matches('[data-qty-dec]')) {
        const val = Math.max(parseInt(qs('[data-qty-input]', itemEl).value, 10) - 1, 0);
        changeQuantity(key, val);
      }
      if (e.target.matches('[data-remove]')) removeItem(key);
    });
    el.items?.addEventListener('change', (e)=>{
      if (e.target.matches('[data-qty-input]')) {
        const itemEl = e.target.closest('.cartDrawer__item');
        const key = itemEl.getAttribute('data-key');
        const val = Math.max(parseInt(e.target.value || '1', 10), 0);
        changeQuantity(key, val);
      }
    });

    // Recommendations add
    root.addEventListener('click', (e)=>{
      if (e.target.matches('[data-rec-add]')) {
        const v = e.target.getAttribute('data-variant');
        addVariant(Number(v), 1);
      }
    });

    // Auto-open only if Dawn's native cart drawer is NOT present
    document.addEventListener('submit', (e)=>{
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = (form.getAttribute('action') || '').replace(location.origin,'');
      if (action === '/cart/add' || action === '/cart/add.js') {
        if (!document.querySelector('cart-drawer')) {
          setTimeout(() => { openDrawer(); render(); }, 300);
        }
      }
    });
  }

  // Boot
  document.addEventListener('DOMContentLoaded', ()=>{
    bind();
    render();
  });

  // Expose for other scripts
  window.setCartCount = setCartCount;
  window.CartDrawer = { open: openDrawer, close: closeDrawer, render, addVariant };
})();

/* =========================
   Force AJAX Add on product pages (Dawn-compatible)
   ========================= */
(function () {
  function isDirectCheckout(submitter) {
    if (!submitter) return false;
    const n = (submitter.getAttribute('name') || '').toLowerCase();
    return submitter.hasAttribute('data-direct-checkout') || n === 'checkout' || n === 'buy_now';
  }

  async function ajaxAdd(form, submitter) {
    const fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    if (submitter && submitter.name && submitter.value) fd.append(submitter.name, submitter.value);

    const cartDrawerEl = document.querySelector('cart-drawer');

    // If Dawn's cart drawer is present, use Dawn's sections flow
    if (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function') {
      try {
        const sections = cartDrawerEl.getSectionsToRender().map((s) => s.id);
        fd.append('sections', sections);
        fd.append('sections_url', window.location.pathname);

        const config = {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        };

        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(addUrl, config);
        const data = await res.json();

        if (data.status) {
          // Broadcast error; don't redirect
          document.dispatchEvent(
            new CustomEvent('cart:add-error', {
              detail: { message: data.message || data.description || 'Unable to add to cart.' }
            })
          );
          return;
        }

        // Render Dawn's drawer
        if (typeof cartDrawerEl.renderContents === 'function') {
          cartDrawerEl.classList.remove('is-empty');
          cartDrawerEl.renderContents(data);
          if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
        }

        // Ask other listeners to refresh counts
        document.dispatchEvent(new CustomEvent('cart:count-updated-request'));
        return;
      } catch (err) {
        console.warn('Dawn sections add failed, falling back to JSON add.', err);
        // Fall through to JSON fallback below
      }
    }

    // Fallback: JSON add, then use your custom drawer if present
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
      if (!res.ok) throw new Error('Add to cart failed');

      // Update count ASAP
      try {
        const cartRes = await fetch('/cart.js', { headers: { 'Accept':'application/json' }});
        const cartData = await cartRes.json();
        if (typeof window.setCartCount === 'function') window.setCartCount(cartData.item_count);
      } catch {}

      if (window.CartDrawer?.render) {
        await window.CartDrawer.render();
        window.CartDrawer.open();
      } else {
        window.location.href = '/cart';
      }
    } catch (e) {
      window.location.href = '/cart';
    }
  }

  // Intercept product add-to-cart submits (capture to beat theme listeners)
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Only intercept cart add forms
    const action = (form.getAttribute('action') || '').replace(location.origin, '');
    if (!/^\/cart\/add/.test(action)) return;

    const submitter = e.submitter || document.activeElement;
    if (isDirectCheckout(submitter)) return; // Let Buy-It-Now / checkout proceed

    e.preventDefault();
    ajaxAdd(form, submitter);
  }, true);
})();
